import classNames from 'classnames'

function hasTitheBarns(upgrades) {
	if (!upgrades) return false
	//pbgids for tithe barns
	return upgrades?.some((upgrade) =>
		[
			'2103125',
			'129407',
			'181968',
			'2124353',
			'2104275',
			'184823',
			'2104276',
		].includes(upgrade),
	)
}

export function LiveGameRelics({
	currentRelics,
	carriedRelics,
	leftSide,
	display = false,
	upgrades,
}) {
	let barns = hasTitheBarns(Object.values(upgrades || {}))

	return (
		<div
			className={classNames(
				'relicDisplay flex',
				!leftSide
					? 'relicDisplay flex-row justify-end'
					: 'flex-row-reverse justify-end',
				display ? 'showRelic' : 'hideRelic',
			)}
		>
			<div
				className={classNames(
					'flex flex-row',
					!leftSide ? 'mr-1' : 'ml-1',
				)}
			>
				<h1
					className={classNames(
						barns ? 'titheBarns text-[#f0c040]' : 'text-white',
					)}
				>
					{currentRelics}
				</h1>
				{carriedRelics != 0 && (
					<h1 className="text-[#b1b1b1]">({carriedRelics})</h1>
				)}
			</div>
			<img
				className={classNames(
					'w-7 h-7 -ml-1 mr-1',
					barns ? 'titheBarns' : '',
				)}
				src="/liveGameIcons/relics.png"
				alt=""
			/>
		</div>
	)
}
